<script lang="ts">
  import type { FiguresBlockComponent } from "$lib/js/strapi/types";

  export let component: FiguresBlockComponent;
</script>

<div class="figures-block">
  <div class="figures-block__inner">
    <h2 class="figures-block__title">{component.headline}</h2>
    
    <div class="figures-block__content">
      <div class="figures-block__highlight">
        <span class="figures-block__number">+ {component.productsCount}</span>
        <p class="figures-block__subtitle">{component.productsText}</p>
      </div>
  
      <div class="figures-block__grid">
        {#each component.categories as category}
          <div class="figures-block__category">
            {category.title}
          </div>
        {/each}
      </div>
    </div>

    {#if component.description}
      <p class="figures-block__footer">{component.description}</p>
    {/if}
  </div>
</div>

<style lang="scss">
  .figures-block {
    padding: 40px 0;

    &__title {
      margin: 0 0 30px;
    }

    &__content {
      @media (min-width: 769px) {
        display: flex;
        gap: 20px;
        align-items: flex-start;
      }
    }

    &__highlight {
      background-color: var(--main);
      color: white;
      padding: 20px;
      border-radius: 4px;
      text-align: center;
      margin-bottom: 10px;
      width: calc(100% - 40px);
      
      @media (min-width: 769px) {
        max-width: 160px;
      }

      p {
        font-size: 14px;
        color: white;
        margin: 0;
      }
    }

    &__number {
      font-size: 34px;
      font-weight: 900;
    }

    &__grid {
      flex-grow: 1;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
      gap: 10px;
      margin-bottom: 30px;
    }

    &__category {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
      border: 1px solid black;
      border-radius: 4px;
      padding: 10px;
      text-align: center;
      font-size: 1rem;
      transition: transform 0.2s ease;
    }

    @media (max-width: 768px) {
      &__grid {
        grid-template-columns: 1fr;
      }
    }
  }
</style>
